import { render, staticRenderFns } from "./AccountHistory.vue?vue&type=template&id=082c1a9d&"
import script from "./AccountHistory.vue?vue&type=script&lang=js&"
export * from "./AccountHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports